import api from './api';

export const createSearch = (query, asyncMode = true) =>
  api.post('/intelligence/search', { query, async: asyncMode });

export const fetchSearch = (queryId) =>
  api.get(`/intelligence/search/${queryId}`);

export const fetchSearchHistory = (params) =>
  api.get('/intelligence/search', { params });

export const extractIndicators = (text) =>
  api.post('/intelligence/extract', { text });

export const promoteEntity = (payload) =>
  api.post('/intelligence/promote', payload);

export const fetchEntityLinks = (entityType, entityId) =>
  api.get('/intelligence/links', { params: { entity_type: entityType, entity_id: entityId } });

export const createEntityLink = (payload) =>
  api.post('/intelligence/links', payload);

export const deleteEntityLink = (linkId) =>
  api.delete('/intelligence/links', { params: { link_id: linkId } });

export const searchEntities = ({
  q = '',
  types,
  excludeType,
  excludeId,
  limit = 20,
} = {}) =>
  api.get('/intelligence/entity-search', {
    params: {
      q,
      ...(types?.length ? { types: types.join(',') } : {}),
      ...(excludeType ? { exclude_type: excludeType } : {}),
      ...(excludeId ? { exclude_id: excludeId } : {}),
      limit,
    },
  });

export const suggestAddresses = (q, { limit = 8 } = {}) =>
  api.get('/intelligence/address-suggest', {
    params: { q, limit },
  });

export const fetchInvestigationGraph = (entityType, entityId, depth = 1) =>
  api.get('/intelligence/graph', { params: { entity_type: entityType, entity_id: entityId, depth } });

export const deleteSearch = (queryId) =>
  api.delete(`/intelligence/search/${queryId}`);

export const runLiveCarrierLookup = (queryId) =>
  api.post(`/intelligence/search/${queryId}/live-carrier`);

export const startCompare = (payload) =>
  api.post('/intelligence/compare', payload);

export const fetchCompare = (searchIdA, searchIdB) =>
  api.get('/intelligence/compare', { params: { search_id_a: searchIdA, search_id_b: searchIdB } });

export const fetchCorpus = (query) =>
  api.get('/intelligence/corpus', { params: query ? { q: query } : {} });

export const ingestCorpusText = (title, contentText) =>
  api.post('/intelligence/corpus', { action: 'ingest_text', title, content_text: contentText });

export const ingestCorpusFile = (file) => {
  const form = new FormData();
  form.append('action', 'ingest_file');
  form.append('file', file);
  return api.post('/intelligence/corpus', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const runPanelHunter = (urls) =>
  api.post('/intelligence/panel-hunter', { urls });
